import type { Region } from '../../models/Region';
import type { SupabaseClient } from 'jsr:@supabase/supabase-js@2';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, name, created_at`;

export class RegionRepository extends SupabaseRepository<Region> {
  constructor(client: SupabaseClient) {
    super('regions', selector, client);
  }
}
